import { ProgressBar } from "primereact/progressbar";
import React from "react";
import AttachmentIcon from "~/components/Processes/conversations/AttachmentIcon";
import {
  formatFileSize,
  getDocumentLabel,
  openFileInNewTab,
} from "~/utils/fileUtils";
import { TreeSelect } from "primereact/treeselect";
import TaskCommentError from "./TaskCommentError";
import PropTypes from "prop-types";
const TaskAttachmentList = ({
  files,
  onFileRemove,
  isLoading,
  handleSelectCategory,
  treeData,
  isPayslipFile = false,
  tryAgainHandler,
}) => {
  return (
    <div>
      {files.length ? <p className="heading">Files Uploaded</p> : null}
      <div
        className={`attachment__list ${files.length > 2 ? "list__overflow" : ""}`}
      >
        {files.map((data, index) => {
          return (
            <>
              <div className="w-full attachment__card">
                <div className="flex align-items-center justify-content-between">
                  <div className="flex align-items-center w-6">
                    <span className="attachment__card--icon">
                      <AttachmentIcon file={data?.file} />
                    </span>
                    <div className="w-full">
                      <div className="attahment__file__detail">
                        <p onClick={() => openFileInNewTab(data?.file)}>
                          {data?.file?.name}
                        </p>
                        <p>
                          {getDocumentLabel(data?.file?.name)}. File Size:{" "}
                          {formatFileSize(data?.file?.size)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex align-items-center gap-4">
                    {isPayslipFile ? (
                      <div className="payslip-input">
                        <p>Payslip</p>
                        <i className="pi pi-lock" />
                      </div>
                    ) : (
                      <TreeSelect
                        value={data.code}
                        onChange={(e) => handleSelectCategory(e, index)}
                        options={treeData}
                        placeholder="Select a Category"
                        filter
                        selectionMode="single"
                        panelClassName="category-tree-panel"
                      />
                    )}
                    <i
                      className={`pi pi-external-link action-icon`}
                      onClick={() => openFileInNewTab(data?.file)}
                    />
                    <i
                      className={`pi pi-times action-icon`}
                      onClick={() => onFileRemove(data)}
                    />
                  </div>
                </div>
                {isLoading && (
                  <ProgressBar
                    value={40}
                    mode="indeterminate"
                    color="#188A42"
                    showValue={false}
                  ></ProgressBar>
                )}
              </div>

              {data &&
                data.error &&
                Object.keys(data.error).length > 1 &&
                !isLoading && (
                  <TaskCommentError
                    summary={data.error.summary}
                    detail={data.error.detail}
                    otherAction={data.error?.otherAction}
                    handleOtherAction={() => tryAgainHandler(data)}
                  />
                )}
            </>
          );
        })}
      </div>
    </div>
  );
};

TaskAttachmentList.protoTypes = {
  files: PropTypes.array,
  onFileRemove: PropTypes.func,
  isLoading: PropTypes.bool,
  handleSelectCategory: PropTypes.func,
  treeData: PropTypes.array,
  isPayslipFile: PropTypes.bool,
  tryAgainHandler: PropTypes.func,
};

export default TaskAttachmentList;
